import { render, staticRenderFns } from "./LanguageSetting.vue?vue&type=template&id=ca522c5e"
import script from "./LanguageSetting.vue?vue&type=script&lang=ts"
export * from "./LanguageSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports